<template>
    <div class="card-document-details">
      <BaseTitle class="card-document__title" tag="h3">
        <a :href="content.url">{{ content.title }}</a>
        <ElementTag class="is-yellow" v-if="content.size" :text="content.size" />
      </BaseTitle>
      <div class="card-document-details__files">
        <ElementIconText icon="documents" v-if="content.documentType" :text="content.documentType.name" />
        <CardDocumentAnnexes v-if="content.annexes.length" :annexes="content.annexes" />
      </div>
      <div class="card-document-details__infos" v-if="isDesktop">
        <div class="card-document-details__body" v-show="showInfos">
          <ElementIconText icon="topics" :text="content.topics" v-if="content.topics.length" />
          <ElementIconText icon="subtopics" :text="content.subtopics" v-if="content.subtopics.length" />
          <ElementIconText icon="workgroups" :text="content.workgroups" v-if="content.workgroups.length" />
          <ElementIconText icon="events" :text="content.date" v-if="content.date" />
          <ElementIconText icon="number" :text="content.reference" v-if="content.reference" />
        </div>
        <a href="javascript:void(0);" class="card-document-details__trigger" @click.prevent.stop="handleClick">
          <span v-if="!showInfos">{{ $t('message.common.buttons.moreDetails') }}</span>
          <span v-else>{{ $t('message.common.buttons.closeDetails') }}</span>
          <BaseIcon :type="icon" />
        </a>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseIcon from '@base/BaseIcon'
import BaseTitle from '@base/BaseTitle'
import ElementTag from '@elements/ElementTag'
import ElementIconText from '@elements/ElementIconText'
import CardDocumentAnnexes from './CardDocumentAnnexes'
export default {
  name: 'CardDocumentDetails',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  components: {
    BaseIcon,
    BaseTitle,
    ElementTag,
    ElementIconText,
    CardDocumentAnnexes
  },
  data () {
    return {
      showInfos: false
    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice'
    }),
    icon () {
      return !this.showInfos ? 'chevron-down' : 'chevron-up'
    },
    isDesktop () {
      return this.device === 'desktop'
    }
  },
  methods: {
    handleClick () {
      this.showInfos = !this.showInfos
    }
  }
}
</script>

<style lang="scss">
  .card-document-details{
    font-size: 1.4rem;
    flex: 1;

    // Card Document SMALL

    .card-document--small &{
      .card-document__title a{
        font-size: 1.6rem;
      }
      .tag{
        display: none;
      }
      a{
        font-size: 1.3rem;
      }
    }

    // Files

    &__files{
      @media print {
        display: none !important;
      }
      @include media("small-medium"){
        flex-direction: column;
      }
      @include media("large"){
        align-items: baseline;
        > *{
          margin-right: layout("spacing")/2;
        }
      }

      display: flex;
      justify-content: flex-start;
    }

    // Infos

    &__infos{
      @media print {
        display: none !important;
      }
    }

    // Trigger

    &__trigger{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: layout("spacing")/2;
      .icon{
        font-size: 1.4rem;
        margin-left: .5rem;
      }
    }

    // Body

    &__body{
      padding-top: layout("spacing")/2;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;

      > *{
        flex: 0 1 auto;
        &:not(:last-of-type){
          margin-right: layout("spacing")/2;
        }
      }
    }
  }
</style>
